import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/firstRecharge/frch_tab_jiantou.png'
import _imports_1 from '@/assets/firstRecharge/frch_title_icon.png'
import _imports_2 from '@/assets/firstRecharge/frch_sttaus_notstart.png'
import _imports_3 from '@/assets/firstRecharge/frch_status_unactivated.png'


const _hoisted_1 = { class: "bannerContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "recharge_content" }
const _hoisted_4 = { class: "recharge_container" }
const _hoisted_5 = { class: "subContainer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "selectIcon" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  style: {"padding-bottom":"15px"}
}
const _hoisted_10 = { class: "detailsCard" }
const _hoisted_11 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_13 = { class: "tableContainer" }
const _hoisted_14 = { class: "depositBtnContainer" }
const _hoisted_15 = {
  key: 0,
  class: "statusButton"
}
const _hoisted_16 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_17 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_18 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_19 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_20 = {
  key: 0,
  class: "bottom_text"
}

import CustomHeader from '../components/common/customHeader.vue';

import { FirstDepositData } from '@/view/firstDeposit/newFirstRecharge';


export default /*@__PURE__*/_defineComponent({
  __name: 'newFirstRecharge',
  props: {
    dataSet: {}
  },
  emits: ['goToDeposit','selectTab'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const goToDeposit = () => {
     emits("goToDeposit")
}

const setActivityStatus = () => {
    return props.dataSet.selectedTabData.record?.status
}

const selectTab = (item: any) => {
    emits("selectTab",item)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.daily_first_recharge')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.configList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "day_num",
              key: index,
              onClick: ($event: any) => (selectTab(item))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["numberText", _ctx.dataSet.selectedTabData?.day === item?.day ? 'activeNumText' : '']),
                style: _normalizeStyle({
                        backgroundImage: _ctx.dataSet.selectedTabData?.day === item?.day
                            ? `url(${require('@/assets/firstRecharge/tab_select.png')})`
                            : `url(${require('@/assets/firstRecharge/frch_tab_default.png')})`
                    })
              }, _toDisplayString(item?.day), 7),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.dataSet.selectedTabData?.day === item?.day)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9))
              ])
            ], 8, _hoisted_6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_row, { class: "cardTitle" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "2",
              class: "titleImage"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "20",
              style: {"padding-left":"5px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('activity.firstDepositTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "24",
              class: "textImage"
            }, {
              default: _withCtx(() => [
                (_ctx.dataSet.selectedTabData?.activeStatus === 1 && _ctx.dataSet.isRewardEligible)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : (_openBlock(), _createElementBlock("img", _hoisted_12))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_row, { class: "tableHead" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "12",
                class: "tableTitle",
                style: {"border-right":"1px solid #998ba18a"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.depositAmount')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "tableTitle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.additionalBonus')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.selectedTabData?.recharge_config, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"padding":"0 20px"},
              key: i
            }, [
              _createVNode(_component_van_row, { style: {"border-bottom":"1px solid #998ba18a"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tableTitle tabelValue1"
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createTextVNode("R$ ")),
                      _createElementVNode("span", null, _toDisplayString(item?.amount), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tableTitle tabelValue2"
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createTextVNode("R$ ")),
                      _createElementVNode("span", null, _toDisplayString(item?.credits), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.dataSet.selectedTabData?.record)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (setActivityStatus() == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                    : (setActivityStatus() == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                      : (setActivityStatus() == 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.dataSet.selectedTabData?.activeStatus === 1 && _ctx.dataSet.isRewardEligible ? 'depositBtn' : 'deposit-disabled'),
                  onClick: goToDeposit
                }, _toDisplayString(_ctx.$t('activity.immediateDeposit')), 3))
          ])
        ])
      ])
    ]),
    (_ctx.dataSet.activityInfo?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "6",
                class: ""
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "line1" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "6",
                class: ""
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "line2" }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})